"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IFramePopover = void 0;
var _react = _interopRequireDefault(require("react"));
var _iframeResizerReact = _interopRequireDefault(require("iframe-resizer-react"));
var _propTypes = require("prop-types");
var _Spinner = _interopRequireDefault(require("@rio-cloud/rio-uikit/lib/es/Spinner"));
var IFramePopover = function IFramePopover(props) {
  var isLoading = props.isLoading,
    iFrameUrl = props.iFrameUrl,
    iframeResizerOptions = props.iframeResizerOptions;
  return /*#__PURE__*/_react.default.createElement("div", null, isLoading && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      height: '50px',
      alignItems: 'flex-end'
    }
  }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    isDoubleSized: true
  })), /*#__PURE__*/_react.default.createElement(_iframeResizerReact.default, {
    id: 'popover-iframe',
    src: iFrameUrl,
    minHeight: iframeResizerOptions.minHeight,
    checkOrigin: iframeResizerOptions.checkOrigin,
    onInit: iframeResizerOptions.onInit,
    onMessage: iframeResizerOptions.onMessage,
    style: {
      width: '1px',
      minWidth: '100%',
      border: '0'
    }
  }));
};
exports.IFramePopover = IFramePopover;
IFramePopover.propTypes = {
  isLoading: _propTypes.PropTypes.bool,
  iFrameUrl: _propTypes.PropTypes.string.isRequired,
  iframeResizerOptions: _propTypes.PropTypes.object.isRequired
};